module.exports = __webpack_public_path__ + "static/media/times.5eabc2bc.png";